import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Button, Label } from 'reactstrap'
import { useEffect, useState } from 'react'
import { ExpectedDeliveryStatusActions } from 'Stores/expectedDeliveryStatusStore'
import Proxies from 'Components/proxies'
import moment from 'moment'
import { Box } from '@material-ui/core'
const { GET } = Proxies

function ExpectedDeliveryStatusLinkModal(props) {
  const [expectedDeliveryStatusId, setExpectedDeliveryStatusId] = useState(props.ExpectedDeliveryStatusID)
  const [variationId, setVariationId] = useState('')
  const [productId, setProductId] = useState('')
  const [supplierId, setSupplierId] = useState(props.SupplierID)
  const [timeStart, setTimeStart] = useState('')
  const [timeEnd, setTimeEnd] = useState('')
  const [suppliers, setSuppliers] = useState([])
  const [expectedDeliveryStatuses, setExpectedDeliveryStatuses] = useState([])

  const fetchSuppliers = async () => {
    const suppliersResult = await GET('suppliers/pool')
    setSuppliers(suppliersResult)
  }

  const fetchExpectedDeliveryStatuses = async () => {
    const expectedDeliveryStatusesResult = await GET('expectedDeliveryStatuses/pool')
    setExpectedDeliveryStatuses(expectedDeliveryStatusesResult)
  }

  const onSubmit = () => {
    const link = {
      ExpectedDeliveryStatusID: Number(expectedDeliveryStatusId),
      VariationID: Number(variationId),
      ProductID: Number(productId),
      SupplierID: Number(supplierId),
      timeStart: timeStart ? moment(timeStart).format('YYYY-MM-DD') : '',
      timeEnd: timeEnd ? moment(timeEnd).format('YYYY-MM-DD') : ''
    }
    const linkType = props.linkType === 'ExpectedDeliveryStatus' ? 'Supplier' : props.linkType
    ExpectedDeliveryStatusActions.saveExpectedDeliveryStatusLink(linkType, link)
    props.toggle()

    setExpectedDeliveryStatusId(props.ExpectedDeliveryStatusID)
    setVariationId('')
    setProductId('')
    setSupplierId(props.SupplierID)
    setTimeStart('')
    setTimeEnd('')
  }

  useEffect(() => {
    setExpectedDeliveryStatusId(props.ExpectedDeliveryStatusID)
  }, [props.ExpectedDeliveryStatusID])

  useEffect(() => {
    setSupplierId(props.SupplierID)
  }, [props.SupplierID])

  useEffect(() => {
    if (props.linkType === 'Supplier') {
      fetchSuppliers()
    }

    if (props.linkType === 'ExpectedDeliveryStatus') {
      fetchExpectedDeliveryStatuses()
    }
  }, [props.linkType])

  return (
    <Modal isOpen={props.isOpen}>
      <ModalHeader toggle={props.toggle}>
        Tilføj leveringsstatus til {props.linkType === 'Product' ? 'produkt' : props.linkType === 'Variation' ? 'variation' : 'leverandør'}
      </ModalHeader>
      <ModalBody style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        {props.linkType === 'ExpectedDeliveryStatus' && (
          <Input type='select' value={expectedDeliveryStatusId} onChange={e => setExpectedDeliveryStatusId(e.target.value)}>
            <option value=''>Vælg en leveringsstatus</option>
            {expectedDeliveryStatuses.map(status => (
              <option key={status.ExpectedDeliveryStatusID} value={status.ExpectedDeliveryStatusID}>
                {status.name}
              </option>
            ))}
          </Input>
        )}

        {props.linkType === 'Supplier' && (
          <Input type='select' value={supplierId} onChange={e => setSupplierId(e.target.value)}>
            <option value=''>Vælg en leverandør</option>
            {suppliers.map(supplier => (
              <option key={supplier.SupplierID} value={supplier.SupplierID}>
                {supplier.supplierName}
              </option>
            ))}
          </Input>
        )}

        {props.linkType === 'Product' && (
          <Input type='number' placeholder='Indtast produkt ID' value={productId} onChange={e => setProductId(e.target.value)} />
        )}

        {props.linkType === 'Variation' && (
          <Input type='number' placeholder='Indtast variation ID' value={variationId} onChange={e => setVariationId(e.target.value)} />
        )}

        <Box>
          <Label for='timeStart'>Startdato</Label>
          <Input type='date' value={timeStart} onChange={e => setTimeStart(e.target.value)} />
        </Box>

        <Box>
          <Label for='timeEnd'>Slutdato</Label>
          <Input type='date' value={timeEnd} onChange={e => setTimeEnd(e.target.value)} />
        </Box>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onSubmit()
          }}
        >
          Confirm
        </Button>
        <Button color='danger' onClick={props.toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ExpectedDeliveryStatusLinkModal
